module.exports = __webpack_public_path__ + "static/media/IMG-20201016-WA0015.0e83f0ac.jpg";